/**
 * Isometric design tokens exposed to JavaScript.
 *
 * The visual language (angles, edge thickness, faces, shadows) lives in
 * `src/styles.css` under the `--iso-*` custom properties. Only values that
 * scripts must know — scroll-drift amplitudes and grid opacity steps — are
 * mirrored here so components never invent their own numbers.
 */
export const ISO_TOKENS = {
  /** Vertical parallax amplitude, in px, for the floor-plan backdrop. */
  driftGrid: 22,
  /** Vertical parallax amplitude, in px, for isometric artwork. */
  driftArt: 18,
  /** Multiplier applied to viewport progress before clamping to the amplitude. */
  driftGain: 1.4,
  /** Opacity steps of the floor grid backdrop. */
  gridIntensity: {
    soft: "opacity-30",
    medium: "opacity-60",
    strong: "opacity-100",
  },
  /** Max rendered height of an isometric illustration. */
  artMaxHeight: "max-h-[420px]",
} as const;

export type IsoIntensity = keyof typeof ISO_TOKENS.gridIntensity;
